<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="Pricing"></mat-tab>
  <mat-tab label="Availability" *ngIf="property?.can_manage_availability">
    <div class="py-4">
      <sbnb-property-availability-rules-form
        *ngIf="property?.can_manage_availability"
        [property]="property"></sbnb-property-availability-rules-form>
    </div>
  </mat-tab>
</mat-tab-group>
